import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatPseudoCheckboxModule, MatRippleModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatTabsModule } from '@angular/material/tabs';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { NoItemPlaceholderModule } from '@portal-core/general/components/no-item-placeholder/no-item-placeholder.module';
import { StopPropagationModule } from '@portal-core/general/directives/stop-propagation/stop-propagation.module';
import { LicenseUserProjectsListModule } from '@portal-core/license-users/components/license-user-projects-list/license-user-projects-list.module';
import { LicenseUserTeamsListModule } from '@portal-core/license-users/components/license-user-teams-list/license-user-teams-list.module';
import { ProjectAvatarModule } from '@portal-core/projects/components/project-avatar/project-avatar.module';
import { ProjectsSelectListModule } from '@portal-core/projects/components/projects-select-list/projects-select-list.module';
import { ProjectAsyncModule } from '@portal-core/projects/pipes/project-async/project-async.module';
import { TeamAvatarModule } from '@portal-core/teams/components/team-avatar/team-avatar.module';
import { TeamsSelectListModule } from '@portal-core/teams/components/teams-select-list/teams-select-list.module';
import { TeamAsyncModule } from '@portal-core/teams/pipes/team-async/team-async.module';
import { AutocompleteInputModule } from '@portal-core/ui/autocomplete/components/autocomplete-input/autocomplete-input.module';
import { DropdownArrowModule } from '@portal-core/ui/forms/components/dropdown-arrow/dropdown-arrow.module';
import { FilterBarModule } from '@portal-core/ui/page-filters/components/filter-bar/filter-bar.module';
import { PopupModule } from '@portal-core/ui/popup/popup.module';
import { McColorModule } from '@portal-core/ui/themes/directives/mc-color.module';
import { UserAccessFormComponent } from './user-access-form.component';

@NgModule({
  declarations: [UserAccessFormComponent],
  imports: [
    McColorModule,
    AutocompleteInputModule,
    CommonModule,
    ErrorsExpansionPanelModule,
    FormsModule,
    LoaderModule,
    NoItemPlaceholderModule,
    ProjectAvatarModule,
    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatListModule,
    MatProgressBarModule,
    MatPseudoCheckboxModule,
    MatRippleModule,
    MatTabsModule,
    MatTreeModule,
    MatTooltipModule,
    StopPropagationModule,
    TeamAvatarModule,
    ProjectAsyncModule,
    TeamAsyncModule,
    LicenseUserTeamsListModule,
    LicenseUserProjectsListModule,
    FilterBarModule,
    PopupModule,
    DropdownArrowModule,
    MatInputModule,
    TeamsSelectListModule,
    ProjectsSelectListModule
  ],
  exports: [UserAccessFormComponent]
})
export class UserAccessFormModule { }
